import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SearchResults from './SearchResults';
import PeopleSearchResult from './PeopleSearchResult';

export const PeopleSearchResults = ({ ...props }) => {
  if (props.results.length) {
    return (
      <SearchResults
        {...props}
        ResultComponent={PeopleSearchResult}
      />
    );
  }

  return false;
};

PeopleSearchResults.propTypes = {
  results: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  results: state.search.services.peopleSearch.results,
});

export default connect(mapStateToProps)(PeopleSearchResults);
